export default __webpack_public_path__ + "static/media/arrow.e0e8f1ef.svg";